module.exports = __webpack_public_path__ + "img/gartek-portfolio-commercial.d2849c78.jpeg";